export default function toggleWaitCursor(req, res) {
    window.handleChaynsCalls('waitCursor', req.value || req, res);
}
